<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <b-notification :closable="false">
              La présente "Politique de confidentialité" décrit les données
              personnelles collectées par le site <em>labos1point5.org</em> et
              par les services auxquels vous accédez via ce site Web. Nous
              détaillons les raisons de cette collecte de données et la façon
              dont elles sont traitées. Vous y trouverez également en
              <a class="link" href="#exercer-vos-droits">bas de page</a> les
              coordonnées dont vous avez besoin si vous avez des questions ou
              des demandes concernant vos données (accès, rectification,
              effacement).
              <br />
              Nous n’utilisons vos données personnelles que dans les cas prévus
              par la réglementation en vigueur et afin de répondre aux besoins
              des activités de <em>labos 1point5</em>, notamment la distribution
              de lettres d’information, la réalisation d’enquêtes et l’activité
              du site Web.
            </b-notification>
            <br />
            <h2>
              Le site WEB '<a class="link" href="http://labos1point5.org/"
                >http://labos1point5.org/</a
              >'
            </h2>
            <br />
            <b-notification :closable="false">
              <strong>Les données collectées :</strong> dépôt de cookies sur
              votre navigateur dans le cas d'une utilisation avec
              authentification. Le blocage des cookies par votre navigateur
              n’empêchera pas la consultation du site labo1point5.org, mais
              certains services ne pourront plus fonctionner.
              <br />
              <strong>Finalités :</strong> fonctionnement et optimisation de la
              navigation authentifiée sur notre site.
              <br />
              <strong>Base légale pour le traitement des données : </strong> les
              cookies utilisés par le site <em>labos1point5.org</em>
              sont d'ordre technique (exemple : gestion de l'authentification)
              et en accord avec la réglementation ne nécessitent pas un
              consentement préalable de l'utilisateur.
              <br />
              <strong>Qui a accès aux données :</strong> les données sont
              exclusivement stockées sur votre ordinateur.
              <br />
              <strong>Vos droits :</strong> les navigateurs internet offre la
              possibilité d’effacer les cookies ou de prévenir leur
              installation. Consulter la rubrique d’aide de votre navigateur
              pour gérer ces options.
              <br />
              <strong>Durée de conservation :</strong> 1 an.
              <br />
              <strong>Processeurs tiers :</strong> aucun.
            </b-notification>
            <br />
            <h2>
              Formulaire '<a class="link" href="/rejoindre-gdr"
                >Rejoindre le GDR</a
              >'
            </h2>
            <br />
            <b-notification :closable="false">
              <strong>Les données collectées :</strong> genre, email, nom,
              prénom, année de naissance, statut, discipline, le nom du
              laboratoire, la ville du laboratoire, les tutelles du laboratoire,
              le %ETP d'engagement, le message d'inscription au sein d'un axe /
              d'une équipe du GDR.
              <br />
              <strong>Finalités :</strong> Ces données sont collectées afin de
              coordonner les activités du GDR <em>labos 1point5</em> et produire
              des statistiques anonymes.
              <br />
              <strong>Base légale pour le traitement des données : </strong> ces
              données ne sont traitées qu'avec votre consentement explicite.
              Pour plus de simplicité, la saisie et l’envoi du formulaire vaut
              consentement.
              <br />
              <strong>Qui a accès aux données :</strong> les données
              personnelles sont uniquement accessibles à l'équipe coordination
              de <em>labos 1point5</em>.
              <br />
              <strong>Durée de conservation :</strong> 10 ans.
              <br />
              <strong>Processeurs tiers :</strong> aucun.
            </b-notification>
            <br />
            <h2>
              Formulaire '<a class="link" href="/rejoindre-reflexion"
                >Rejoindre l'équipe réflexion</a
              >'
            </h2>
            <br />
            <b-notification :closable="false">
              <strong>Les données collectées :</strong> genre, email, nom,
              prénom, année de naissance, statut, discipline, le nom du
              laboratoire, la ville du laboratoire, les tutelles du laboratoire,
              quelques mots sur votre parcours / engagement dans le monde
              associatif/institutionnel.
              <br />
              <strong>Finalités :</strong> Ces données sont collectées afin de
              coordonner les activités de l'équipe « Réflexion » du
              <em>labos 1point5</em> et produire des statistiques anonymes.
              <br />
              <strong>Base légale pour le traitement des données : </strong> ces
              données ne sont traitées qu'avec votre consentement explicite.
              Pour plus de simplicité, la saisie et l’envoi du formulaire vaut
              consentement.
              <br />
              <strong>Qui a accès aux données :</strong> les données
              personnelles sont uniquement accessibles à l'équipe coordination
              de <em>labos 1point5</em>.
              <br />
              <strong>Durée de conservation :</strong> 10 ans.
              <br />
              <strong>Processeurs tiers :</strong> aucun.
            </b-notification>
            <br />
            <h2>Formulaire '<a class="link" href="/">Nous contacter</a>'</h2>
            <br />
            <b-notification :closable="false">
              <strong>Les données collectées :</strong> email, nom, prénom et
              votre message.
              <br />
              <strong>Finalités :</strong> ces données sont collectées afin de
              répondre aux questions des membres du collectif.
              <br />
              <strong>Base légale pour le traitement des données : </strong> ces
              données ne sont traitées qu'avec votre consentement explicite.
              Pour plus de simplicité, la saisie et l’envoi du formulaire vaut
              consentement.
              <br />
              <strong>Qui a accès aux données :</strong> les données
              personnelles sont uniquement accessibles à l'équipe coordination
              de <em>labos 1point5</em>.
              <br />
              <strong>Durée de conservation :</strong> 10 ans.
              <br />
              <strong>Processeurs tiers :</strong> aucun.
            </b-notification>
            <br />
            <h2>
              Formulaire '<a class="link" href="/les-initiatives"
                >Proposer votre initiative</a
              >'
            </h2>
            <br />
            <b-notification :closable="false">
              <strong>Les données collectées :</strong> email du contact, nom du
              contact, prénom du contact, nom du laboratoire, tutelles du
              laboratoire, position du laboratoire, description et initiatives
              mises en place (groupe de réflexion, déplacements professionnels,
              déplacements domicile-travail, activités de recherche, bâtiments,
              actions éco-responsables, initiatives à portée sociale, enquêtes,
              communication et autre).
              <br />
              <strong>Finalités :</strong> ces données sont collectées afin de
              recenser et d'afficher publiquement sur le site WEB les
              initiatives proposées.
              <br />
              <strong>Base légale pour le traitement des données : </strong> ces
              données ne sont traitées qu'avec votre consentement explicite.
              Pour plus de simplicité, la saisie et l’envoi du formulaire vaut
              consentement.
              <br />
              <strong>Qui a accès aux données :</strong> les données sont
              affichées publiquement sur le site WEB.
              <br />
              <strong>Durée de conservation :</strong> 10 ans.
              <br />
              <strong>Processeurs tiers :</strong> aucun.
            </b-notification>
            <br />
            <h2>
              Formulaire '<a class="link" href="/data-access-form"
                >Demande d'accès aux données <em>Ekocentral GES</em></a
              >'
            </h2>
            <br />
            <b-notification :closable="false">
              <strong>Les données collectées :</strong> e-mail, description du
              projet de recherche ou du traitement / opération / maintenance à
              faire sur la base de données.
              <br />
              <strong>Finalités :</strong> ces données sont collectées afin de
              coordonner les activités du GDR <em>Labos 1point5</em>
              et d'avoir la liste des utilisateurs autorisés à accéder à la base
              de données.
              <br />
              <strong>Base légale pour le traitement des données : </strong> ces
              données ne sont traitées qu'avec votre consentement explicite.
              Pour plus de simplicité, la saisie et l’envoi du formulaire vaut
              consentement. Une absence de consentement ne permettra pas de
              valider l'accès à la base de données.
              <br />
              <strong>Qui a accès aux données :</strong> les données
              personnelles sont uniquement accessibles à l'équipe de
              coordination de <em>Labos 1point5</em>.
              <br />
              <strong>Durée de conservation :</strong> 10 ans.
              <br />
              <strong>Processeurs tiers :</strong> aucun.
            </b-notification>
            <br />
            <h2>Faites exercer vos droits</h2>
            <br />
            <b-notification :closable="false">
              En vertu du
              <a
                class="link"
                href="https://ec.europa.eu/commission/priorities/justice-and-fundamental-rights/data-protection/2018-reform-eu-data-protection-rules_en"
                target="_blank"
              >
                règlement général sur la protection des données</a
              >
              (RGPD), vous disposez d’un certain nombre de droits sur vos
              données (consultez le site Web de la
              <a
                class="link"
                href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees"
                target="_blank"
                >Commission nationale de l’informatique et des libertés
                (CNIL)</a
              >
              pour un aperçu de
              <a
                class="link"
                href="https://www.cnil.fr/fr/les-droits-pour-maitriser-vos-donnees-personnelles"
                target="_blank"
                >ceux-ci</a
              >).
              <br />
              Vous disposez d'un droit d'accès, de rectification, de
              suppression, d'opposition (pour un motif légitime) ou de
              limitation d'utilisation des données vous concernant, conformément
              à la loi n ° 78-17 du 6 janvier 1978 relative à l'informatique,
              aux fichiers et aux libertés, et avec le règlement de l'UE
              2016/679 relatif à la protection des personnes physiques à l'égard
              du traitement des données à caractère personnel et à la libre
              circulation de ces données.
              <br />
              Le Délégué à la protection des données de
              <em>labos 1points5</em> est votre interlocuteur pour toute demande
              d’exercice de vos droits sur ces traitements. Vous pouvez le
              contacter en remplissant ce
              <router-link class="link" to="/"
                >formulaire de contact</router-link
              >. Après avoir contacté notre DPD, si vous estimez que vos droits
              sur vos données ne sont pas respectés, vous pouvez adresser une
              réclamation auprès de la
              <a
                class="link"
                target="_blank"
                href="https://www.cnil.fr/fr/webform/adresser-une-plainte"
                >CNIL</a
              >.
            </b-notification>
          </div>
        </div>
        <br />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
h2 {
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  line-height: 1px;
  margin: 0 0 5px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #aaaaaa;
  font-family: 'Poppins', sans-serif;
}
h2::after {
  content: '';
  width: 120px;
  height: 1px;
  display: inline-block;
  background: #6c8fd6;
  margin: 4px 10px;
}
</style>
